import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { BabylonActions, ReactBabylonLink } from '../../../babylon';
import StableService from '../../../services/stable.service';
import * as log from '../../../utils/log';
import * as Wallet from '../../../wallet/api';
export const getHorses = createAsyncThunk('horses/pages', async ({ walletId }) => {
    try {
        return await Wallet.getHorses(walletId);
    }
    catch (err) {
        return err.response;
    }
});
export const getHorse = createAsyncThunk('horse/id', async (asset) => {
    try {
        return await Wallet.getHorse(asset);
    }
    catch (err) {
        return err.response;
    }
});
export const activateHorse = createAsyncThunk('id/activate', async (data) => {
    try {
        return await StableService.activateHorse(data);
    }
    catch (err) {
        return err.response;
    }
});
export const getStableDetails = createAsyncThunk('/stable/details', async ({ id }, thunkApi) => {
    log.debug('Get stables details: loading = true');
    thunkApi.dispatch(setLoading(true));
    return await Wallet.getWalletInfo(id);
});
export const initialState = {
    pending: false,
    error: null,
    horses: [],
    filteredHorses: [],
    horse: null,
    countFilter: null,
    filtersValue: null,
    stableStakeId: null,
    stableDetails: null,
    stableDetailsNavigationBackRoute: null,
    socialStableNavigationBackRoute: null,
    loading: false
};
export const slice = createSlice({
    name: 'stableDetails',
    initialState,
    reducers: {
        saveFilterData: (state, action) => {
            state.filtersValue = action.payload;
        },
        saveFilteredHorses: (state, action) => {
            var _a;
            const assetNames = action.payload
                .map((horse) => horse.static.displayName)
                .sort();
            const prevNames = state.filteredHorses
                .map((horse) => horse.static.displayName)
                .sort();
            log.debug(assetNames);
            log.debug(prevNames);
            let reload = action.payload.length !== state.filteredHorses.length;
            if (!reload) {
                reload = prevNames === null || prevNames === void 0 ? void 0 : prevNames.reduce((reload, horse, i) => {
                    const name = assetNames.length > i ? assetNames[i] : null;
                    return reload || horse !== name;
                }, false);
            }
            if (reload === true) {
                state.filteredHorses = action.payload;
                log.warn('Horses filter changed: refreshing the 3d scene');
                (_a = ReactBabylonLink.StateBus.get('isScreenLocked')) === null || _a === void 0 ? void 0 : _a.set(true);
                BabylonActions.RefreshScene();
            }
            else {
                log.debug('Horses filter did not change');
            }
        },
        getStableStakeId: (state, action) => {
            state.stableStakeId = action.payload;
        },
        setStableDetailsNavigateBackRoute: (state, { payload }) => {
            state.stableDetailsNavigationBackRoute = payload;
        },
        setSocialStableNavigateBackRoute: (state, { payload }) => {
            state.socialStableNavigationBackRoute = payload;
        },
        setLoading: (state, { payload }) => {
            state.loading = payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getHorses.fulfilled, (state, action) => {
            state.pending = false;
            state.horses = action.payload;
            // state.filteredHorses = [...action.payload];
            // log.debug(`Resetting the list of filtered horses : ${action.payload.length}`);
            // ReactBabylonLink.StateBus.get('isScreenLocked')?.set(true);
            // BabylonActions.RefreshScene();
        });
        builder.addCase(getHorses.rejected, (state) => {
            state.pending = false;
        });
        builder.addCase(getHorses.pending, (state) => {
            state.pending = true;
        });
        builder.addCase(getHorse.fulfilled, (state, action) => {
            state.pending = false;
            state.horse = action.payload;
        });
        builder.addCase(activateHorse.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.pending = false;
                state.horses =
                    state.horses && state.horses[0]
                        ? state.horses.filter((h) => h.static.asset.assetName !== action.payload.data.asset.assetName, ...action.payload.data)
                        : [];
            }
        });
        builder.addCase(getStableDetails.fulfilled, (state, action) => {
            state.stableDetails = action.payload;
            state.loading = false;
            log.debug('Get stables details done');
        });
        builder.addCase(getStableDetails.rejected, (state) => {
            state.stableDetails = null;
            state.loading = false;
            log.debug('Get stables details error');
        });
    }
});
export const { saveFilterData, getStableStakeId, saveFilteredHorses, setStableDetailsNavigateBackRoute, setSocialStableNavigateBackRoute, setLoading } = slice.actions;
export default slice.reducer;
